import { searchCommonConfig } from './common'

/**
 * Pearla 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: '#0000000A',
    startReadingBg: 'linear-gradient(315deg, #7761F7 0%, #F992FF 100%)',
  },
}
